<template>
  <!-- v-loading="loading" element-loading-text="拼命加载中" -->
  <div class="index ele-box" v-loading="loading" element-loading-text="拼命加载中">
    <div class="fixedTop">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-if="info.provincialAndMunicipalLevel==2" label="县/区级" name="县/区级">
        </el-tab-pane>
        <el-tab-pane label="乡镇/街道级" name="乡镇/街道级">
        </el-tab-pane>
      </el-tabs>
      <!-- <el-tabs v-else v-model="activeName" @tab-click="handleClick">
        <el-tab-pane  label="人员设置" name="人员设置">
        </el-tab-pane>
      </el-tabs> -->

    </div>
    <!-- <div class="title">
      <h3>人员设置</h3>
    </div> -->
    <!-- 县区乡镇 -->
    <div class="topCont">
      <div class="pdaBoxs">
        <el-form ref="form" :model="form">
          <div v-if="info.provincialAndMunicipalLevel==2&&handleIndex==1" style="display: inline-block;margin-right: 15px;vertical-align: top;">
            <el-select v-model="citys" @change="changeCounty" placeholder="请选择" style="margin-right: 15px;">
              <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">{{item.name}}
              </el-option>
            </el-select>
            <el-select v-model="villages" @change="changeVillage" placeholder="请选择">
              <el-option v-for="item in villageList" :key="item.id" :label="item.name" :value="item.id">{{item.name}}
              </el-option>
            </el-select>
          </div>
          <div v-else style="display: inline-block;vertical-align: top">
            <el-form-item style="width: 160px;">
              <el-select @change="changeCitys" v-model="form.queryCityAreas" placeholder="选择辖区">
                <el-option label="全部辖区" value=""></el-option>
                <el-option v-for="(item,index) in cityList" :key="item.id" :label="item.name" :value="item.id">
                  {{item.name}}
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="display: inline-block;vertical-align: top">
            <el-form-item style="width:160px">
              <el-input @input="changeNames" v-model="form.name" placeholder="输入机构名称查询"></el-input>
            </el-form-item>
            <el-form-item style="width:160px">
              <el-input @input="changeName" v-model="form.realName" placeholder="请输入姓名查询"></el-input>
            </el-form-item>
            <el-form-item style="width:160px">
              <el-input @input="changePhone" v-model="form.phone" placeholder="请输入电话号码"></el-input>
            </el-form-item>
            <el-form-item class="items">
              <el-button type="success" plain @click="onSubmit">搜索</el-button>
              <el-button type="info" plain @click="reset" style="background-color: #fff;border:none">重置</el-button>
            </el-form-item>

            <div class="btnBox" v-if="info.provincialAndMunicipalLevel=='2'&&handleIndex==0&&info.optAuthType==2">
              <el-button type="primary" @click="addPerson" style="margin-left:20px">新增 +</el-button>
              <!-- <el-button type="primary">导入 ↘</el-button> -->
            </div>
            <div class="btnBox" v-if="info.provincialAndMunicipalLevel==3&&info.optAuthType==2">
              <el-button type="primary" @click="addPerson" style="margin-left:20px">新增 +</el-button>
            </div>
          </div>
        </el-form>
        <el-dialog :visible.sync="showAddDialog" width="960px" height="600px" @click="closeDialog">
          <el-form label-width="120px">
            <div class="maskBox">
              <h1 style="font-size:20px;">{{addTitle}}</h1>
              <div class="absolutes">
                <div class="layui-form-item leftBlock">
                  <div class="over_h">机构名称<span class="red">*</span></div>
                  <div class="layui-input-block mar_t15">
                    <input type="text" name="Manufacturer" v-model="newData.name" lay-verify="Manufacturer"
                      autocomplete="off" class="layui-input Manufacturer">
                  </div>
                </div>
                <div class="layui-form-item leftBlock cityLists">
                  <div v-if="handleIndex==0&&info.provincialAndMunicipalLevel==2">
                    <div class="over_h">所在辖区<span class="red">*</span><span style="color:#999;float: right;">单选</span>
                    </div>
                    <el-form>
                      <el-form-item style="width: 100%;">
                        <el-select style="margin-top:10px;" placeholder="请选择活动区域" @change="changeCity"
                          v-model="newData.authProvincesCityAreas">
                          <el-option v-for="item in cityList" :label="item.name" :key="item.id" :value="item.id">
                            {{item.name}}
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>
                  </div>
                  <div v-else>
                    <div class="over_h">服务辖区<span class="red">*</span><span style="color:#999;float: right;">多选</span>
                    </div>
                    <el-form>
                      <el-form-item style="width: 100%;">
                        <el-select class="mar_t15" multiple v-model="newData.authProvincesCityAreas"
                          @change="changeCountyXZ" placeholder="请选择">
                          <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
                            {{item.name}}
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
                <div class="layui-form-item leftBlock">
                  <div class="over_h">管理员姓名<span class="red">*</span></div>
                  <div class="layui-input-block mar_t15">
                    <input type="text" name="Manufacturer" v-model="newData.adminUserName" lay-verify="Manufacturer"
                      autocomplete="off" class="layui-input Manufacturer">
                  </div>
                </div>
                <div class="layui-form-item leftBlock">
                  <div class="over_h">管理员手机号码<span class="red">*</span></div>
                  <div class="layui-input-block mar_t15">
                    <input type="text" name="Manufacturer" v-model="newData.adminUserPhone" lay-verify="Manufacturer"
                      autocomplete="off" class="layui-input Manufacturer">
                  </div>
                </div>
                <div class="layui-form-item leftBlock">
                  <div class="over_h">操作员姓名<span class="red">*</span></div>
                  <div class="layui-input-block mar_t15">
                    <input type="text" name="Manufacturer" v-model="newData.optUserName" lay-verify="Manufacturer"
                      autocomplete="off" class="layui-input Manufacturer">
                  </div>
                </div>
                <div class="layui-form-item leftBlock">
                  <div class="over_h">操作员手机号码<span class="red">*</span></div>
                  <div class="layui-input-block mar_t15">
                    <input type="text" name="Manufacturer" v-model="newData.optUserPhone" lay-verify="Manufacturer"
                      autocomplete="off" class="layui-input Manufacturer">
                  </div>
                </div>
              </div>
              <div class="clear"></div>
              <div class="rkConfrim addConfrim clear cur" @click="confirmBtn">确定</div>
            </div>
          </el-form>
        </el-dialog>
        <!-- 新增防疫员 -->
        <el-dialog :visible.sync="showAddsDialog" width="960px" height="300px" @click="closeDialog">
          <el-form label-width="120px">
            <div class="maskBox">
              <h1 style="font-size:20px;">新增防疫员</h1>
              <div class="layui-form-item leftBlock">
                <div class="over_h">防疫员姓名<span class="red">*</span></div>
                <div class="layui-input-block mar_t15">
                  <input type="text" name="Manufacturer" v-model="newFY.realName" lay-verify="Manufacturer"
                    autocomplete="off" class="layui-input Manufacturer">
                </div>
              </div>
              <div class="layui-form-item leftBlock">
                <div class="over_h">防疫员手机号码<span class="red">*</span></div>
                <div class="layui-input-block mar_t15">
                  <input type="text" name="Manufacturer" v-model="newFY.phone" lay-verify="Manufacturer"
                    autocomplete="off" class="layui-input Manufacturer">
                </div>
              </div>
              <div class="layui-form-item leftBlock">
                <div class="over_h" style="display: inline;">备注（片区）：</div>
                <div class="layui-input-block mar_t15" style="display: inline-block;width: calc( 100% - 118px );">
                  <input type="text" name="Manufacturer" v-model="newFY.remarks" lay-verify="Manufacturer"
                    autocomplete="off" class="layui-input Manufacturer">
                </div>
              </div>
            </div>
            <div class="clear"></div>
            <div class="rkConfrim addConfrim clear cur" @click="confirmsBtn">确定</div>
          </el-form>
        </el-dialog>

        <!--防疫员列表-->
        <el-dialog :visible.sync="showFangYiListDialog" width="650px" @click="closeDialog">
          <el-form label-width="120px">
            <div class="maskBox">
              <h1 style="font-size:20px;text-align: left;">防疫员<span>{{xzItem.name}}</span></h1>
              <el-form ref="form" :model="form">
                <el-form-item style="width:160px">
                  <el-input @input="changeNameFY" v-model="listFY.realName" placeholder="请输入姓名查询"></el-input>
                </el-form-item>
                <el-form-item style="width:160px">
                  <el-input @input="changePhoneFY" v-model="listFY.phone" placeholder="请输入电话号码"></el-input>
                </el-form-item>
                <el-form-item class="items">
                  <el-button type="success" plain @click="onSubmitFY">搜索</el-button>
                  <el-button type="info" plain @click="resets" style="background-color: #fff;border:none">重置</el-button>
                </el-form-item>
              </el-form>
              <div class="pages">共 {{totalFY}}条数据</div>
              <el-table class="editTable aaa4" :data="fangyiList" height="350" fixed
                style="width: 100%;text-align: center;">
                </el-table-column>
                <el-table-column prop="" width="50" label="">
                  <template slot-scope="scope">
                    <img v-if="scope.row.avatarUrl!=''&& scope.row.avatarUrl!=null" style="width: 30px;height:30px;border-radius: 50%;"
                      :src="scope.row.avatarUrl" />
                    <img v-else style="width: 30px;height:30px;border-radius: 50%;" src="../../assets/img/u8.png" />
                  </template>
                </el-table-column>
                <el-table-column prop="realName" width="180" label="姓名">
                </el-table-column>
                <el-table-column prop="userAccount" width="150" label="电话号码">
                </el-table-column>
                <el-table-column prop="" width="230" label="">
                </el-table-column>
              </el-table>
            <el-pagination
              background
              :page-size="10"
              layout="prev, pager, next"
              @prev-click="prevFY"
              @next-click="nextFY"
              @current-change="currentPageFY"
              :total="totalFY" style="margin-top:50px">
            </el-pagination>
              <div class="clear"></div>
              <!-- <div class="rkConfrim addConfrim clear cur" @click="confirmBtn">确定</div> -->
            </div>
          </el-form>
        </el-dialog>
        <!--防疫员管理编辑-->
        <el-dialog :visible.sync="showEditDialog" width="960px" @click="closeDialog">
          <el-form label-width="120px">
            <div class="maskBox">
              <h1 style="font-size:20px;text-align: left;">防疫员<span>{{xzItem.name}}</span></h1>
              <el-form ref="form" :model="form">
                <el-form-item style="width:160px">
                  <el-input @input="changeName" v-model="form.realName" placeholder="请输入姓名查询"></el-input>
                </el-form-item>
                <el-form-item style="width:160px">
                  <el-input @input="changePhone" v-model="form.phone" placeholder="请输入电话号码"></el-input>
                </el-form-item>
                <el-form-item class="items">
                  <el-button type="success" plain @click="onSubmitFY">搜索</el-button>
                  <el-button type="info" plain @click="resets" style="background-color: #fff;border:none">重置</el-button>
                </el-form-item>
                <div class="btnBox">
                  <el-button type="primary" @click="addprevention" style="margin-left:20px">新增 +</el-button>
                  <el-button type="primary" @click="download" style="margin-left:20px">模板下载</el-button>
                  <el-button type="primary" @click="imports" style="margin-left:20px;position: relative;">导入数据
                    <input type="file" class="changeFiles" name="" id="" value="文件上传" accept=".xlsx, .xls" @change="changeFile" style="cursor: pointer;position: absolute;width: 106px;height:40px;left: 0;top:0;opacity: 0;" />
                    <label for=""></label>
                  </el-button>



                  </el-upload>
                  </el-form-item>
                </div>
              </el-form>
              <div class="pages">共 {{totalFY}}条数据</div>
              <el-table class="editTable" :data="fangyiList" height="350" fixed style="width: 100%;text-align: center;">
                </el-table-column>
                <el-table-column prop="" width="50" label="">
                  <template slot-scope="scope">
                    <img v-if="scope.row.avatarUrl!=''&& scope.row.avatarUrl!=null" style="width: 30px;height:30px;border-radius: 50%;"
                      :src="scope.row.avatarUrl" />
                    <img v-else style="width: 30px;height:30px;border-radius: 50%;" src="../../assets/img/u8.png" />
                  </template>
                </el-table-column>
                <el-table-column prop="realName" width="180" label="姓名">
                  <template slot-scope="scope">
                    <div v-if="editName==true">{{scope.row.realName}}</div>
                    <div v-else>
                      <el-input @input="changeNFY" v-model="scope.row.realName"></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="userAccount" width="150" label="电话号码">
                  <template slot-scope="scope">
                    <div v-if="editPhone">{{scope.row.userAccount}}</div>
                    <div v-else>
                      <el-input @input="changePFY" v-model="scope.row.userAccount"></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="" width="350" label="">
                </el-table-column>
                <el-table-column prop="action" label="操作">
                  <template slot-scope="scope">
                    <div class="actionBox" v-if="editBtn==true">
                      <div class="cursor showDetail" @click="deleteFY(scope.row)">删除</div>
                      <div class="cursor showDetail" @click="editFangYi(scope.row)">编辑</div>
                    </div>
                    <div class="actionBox" v-else>
                      <div class="cursor cancel" @click="editCancelFangYi(scope.row)">取消</div>
                      <div class="cursor save" @click="editSaveFangYi(scope.row)">保存</div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
             <el-pagination
               background
               :page-size="10"
               layout="prev, pager, next"
               @prev-click="prevFY"
               @next-click="nextFY"
               @current-change="currentPageFY"
               :total="totalFY" style="margin-top:50px">
             </el-pagination>
              <div class="clear"></div>
              <!-- <div class="rkConfrim addConfrim clear cur" @click="confirmBtn">确定</div> -->
            </div>
          </el-form>
        </el-dialog>
        <div>共{{total}}条记录</div>
      </div>
    </div>
    <div class="botCont">
      <el-table class="elTable" :data="userList" height="450" fixed style="width:1800px;">
        <el-table-column type="index" label="序号" width="80">
        </el-table-column>
        <el-table-column prop="name" width="150" label="机构名称">
        </el-table-column>
        <el-table-column prop="authProvincesCityAreasName" align="left" class="leftL"
          :label="handleIndex==0?'所属辖区（单选）' :handleIndex==1?'服务辖区（可多选）':''">
        </el-table-column>

        <!-- <el-table-column
          v-if="handleIndex==1"
          prop="authProvincesCityAreasName"
          align="left"
          class="leftL"
          label="服务的村/社区">
        </el-table-column> -->
        <el-table-column prop="" width="200" label="管理员">
          <template slot-scope="scope">
            <div style="float: left;">
              <img style="width: 30px;height: 30px;border-radius: 50%;margin:5px 10px 0 0"
                src="../../assets/img/u8.png" />
            </div>
            <div class="fl" style="font-size: 14px;">
              <div>{{scope.row.adminUserName}}</div>
              <div>{{scope.row.adminUserPhone}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="optUserName" width="200" label="操作员">
          <template slot-scope="scope">
            <div style="float: left;">
              <img style="width: 30px;height: 30px;border-radius: 50%;margin:5px 10px 0 0"
                src="../../assets/img/u8.png" />
            </div>
            <div class="fl" style="font-size: 14px;">
              <div>{{scope.row.optUserName}}</div>
              <div>{{scope.row.optUserPhone}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="info.provincialAndMunicipalLevel==3"  prop="numberOfImmunizers" width="120" label="防疫员">
          <template slot-scope="scope">
            <div style="text-decoration: underline;cursor: pointer;" @click="fangyiyuan(scope.row)">
              {{scope.row.numberOfImmunizers}}</div>
          </template>
        </el-table-column>
        <el-table-column v-if="handleIndex==0&&info.provincialAndMunicipalLevel==2" prop="action" label="操作"
          width="180">
          <template slot-scope="scope">
            <div class="actionBox tc">
              <div class="cursor showDetail" @click="deletes(scope.row)">删除</div>
              <div class="cursor showDetail" @click="edit(scope.row)">编辑</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="info.provincialAndMunicipalLevel==3" prop="action" label="操作" width="240">
          <template slot-scope="scope">
            <div class="actionBox">
              <div class="cursor showDetail" @click="deletes(scope.row)">删除</div>
              <div class="cursor showDetail" @click="edit(scope.row)">编辑</div>
              <div class="cursor showDetail" @click="addFY(scope.row)">防疫员管理</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
     <el-pagination
       background
       :page-size="10"
       layout="prev, pager, next"
       @prev-click="prev"
       @next-click="next"
       @current-change="currentPage"
       :total="total" style="margin-top:50px">
     </el-pagination>
    </div>
  </div>
</template>
<!-- <script src="https://cdn.bootcss.com/hls.js/8.0.0-beta.3/hls.min.js"></script> -->
<script type="text/javascript" src="https://cdn.bootcss.com/hls.js/8.0.0-beta.3/hls.min.js"></script>
<script type="text/javascript" src="https://cdn.bootcss.com/flv.js/1.5.0/flv.min.js"></script>
<script>
  import Vue from 'vue'
  // import elCascaderMulti from "el-cascader-multi";
  // Vue.use(elCascaderMulti);
  import {
    selectAllDept,
    addDept,
    delDept,
    addOrUpdateAuthUser,
    getUserListByDeptId,
    updateDept,
    delAuthUserFY,
    updateAuthUserFY,
    importExcel,

    // 组织机构



    getUserList,
    delAuthUser,
    selectByPCityAreas,
    addOrUpdate,
    getUserAuthInfo,
    editOrUpdate

  } from '@/api/system'
  export default {
    data() {
      return {
        totalFY:0,
        fileDate: {

        },
        citys: '',
        villages: '',
        options: [],
        loading: true,
        editName: true,
        editPhone: true,
        editBtn: true,
        activeName: '县/区级',
        organizationalName: '组织机构名称',
        handleIndex: 0,
        address: {
          // "code": "",
          "id": 42255
        },
        newData: {
          deptId: '',
          adminUserName: '', //管理员名称
          adminUserPhone: '', //管理员手机号
          name: '', //组织机构名称
          optUserName: '', //操作员名称
          authProvincesCityAreas: [],
          optUserPhone: '', //操作员手机号
          provincialAndMunicipalLevel: '', //级别
        },
        typess: [
          {
            name: '防疫员',
            value: '0'
          },
          {
            name: '操作员',
            value: '1'
          },
          {
            name: '管理员',
            value: '2'
          },

        ],
        showAddDialog: false,
        showEditDialog: false,
        showFangYiListDialog: false,
        form: {
          name: '',
          realName: '',
          authProvincesCityAreas: '',
          pageNo: 1,
          pageSize: 10,
        },
        infoQuery: {

        },
        nextLevelAreaIds: '',
        pageNum: 1,
        total: 0,
        totalPage: 1,
        userList: [],
        fangyiList: [],
        active: null,
        cityList: [],
        info: '',
        addTitle: '新增县区级组织机构',
        villageId: '',
        villageList: [],
        showAddsDialog: false,
        newFY: {
          realName: '',
          phone: '',
          deptId: '',
          id: '',
          remarks:'',
          optAuthType:'0'
        },
        listFY: {
          pageNo: 1,
          pageSize: 10,
          phone: '',
          deptId: ''
        },
        wListItem: '',
        xzItem: '',
        itemFYSta: ''
      }
    },

    async mounted() {
      await this.getUserInfo()

      // await this.getList()

    },
    methods: {
      resets(){
        this.listFY.realName = ''
        this.listFY.phone = ''
        this.listFY.pageNo =1
        this.getListFY()
      },
      changeFile(e) {
        console.log(e)
        let filea = e.target.files[0];
        let file = new FormData();
        file.append("file", filea);
         file.append("deptId", this.xzItem.deptId);
           file.append("optAuthType", this.info.optAuthType);
        // this.fileDate.file = formFiles
        importExcel(file)
          .then(res => {
            if (res.data.code == 0) {
              console.log(res)
              // res.data.data.forEach(item=>{
              //   Vue.set(item,'checked',false)
              // })
              // _this.options = res.data.data
            } else {
              _this.$message({
                type: 'info',
                message: res.data.msg
              })
            }
          })

      },
      download() {
        window.location.href = 'http://test.xiaomuding.com/pasture/tuserauthinfo/downExcelTemp'
      },
      imports() {

        // importExcel,

      },
      changeNFY(e) {
        this.newFY.realName = e
      },
      changePFY(e) {
        this.newFY.phone = e
      },
      changeNameFY(e) {
        this.listFY.realname = e
        this.listFY.pageNo = 1
        this.getListFY()
      },
      changePhoneFY(e) {
        this.listFY.pageNo = 1
        this.listFY.phone = e
        this.getListFY()
      },
      changeCounty(e) {
        this.loading = false

        this.villageId = e
        this.getVillage()
      },
      changeVillage(e) {
        this.form.pageNo = 1
        this.form.authProvincesCityAreas = e
        this.getList()
      },
      getVillage() {
        var _this = this
        selectByPCityAreas({
            id: this.villageId
          })
          .then(res => {
            if (res.data.code == 0) {
              console.log(res)
              // res.data.data.forEach(item=>{
              //   Vue.set(item,'checked',false)
              // })
              _this.villageList = res.data.data
              // _this.options = res.data.data
            } else {
              _this.$message({
                type: 'info',
                message: res.data.msg
              })
            }
          })
      },
      handleClick(tab, event) {
        this.handleIndex = tab.index
        this.form.name = ''
        this.form.realName = ''
        this.form.phone = ''
        this.form.queryCityAreas = ''
        if (this.handleIndex == 0) {
          this.addTitle = '新增县区级组织机构'
          this.form.authProvincesCityAreas = this.info.authProvincesCityAreas
          // this.form.authProvincesCityAreas = this.info.nextLevelAreaIds
        } else {
          this.addTitle = '新增乡镇街道级组织机构'
          this.form.authProvincesCityAreas = this.info.nextLevelAreaIds
        }
        this.getList()

      },
      changeType(e) {
        console.log(e)
        this.form.optAuthType = e
        this.loading = true
        this.getList()
      },
      changeCitys(e) {
        console.log(e)
        this.form.queryCityAreas = e
        this.loading = true
        this.getList()
      },
      getUserInfo() {
        var _this = this
        getUserAuthInfo()
          .then(res => {
            if (res.data.code == 0) {
              this.info = res.data.data
              console.log(this.info)
              this.newData.provincialAndMunicipalLevel = this.info.provincialAndMunicipalLevel
              this.address.id = this.info.authProvincesCityAreas
              this.nextLevelAreaIds = this.info.nextLevelAreaIds
              this.form.authProvincesCityAreas = this.info.authProvincesCityAreas
              this.getList()
              this.cityLs()
            } else {
              _this.$message({
                type: 'info',
                message: res.data.msg
              })
            }
          })
      },
      changeCity(e) {
        console.log(e)
        this.newData.authProvincesCityAreas = e
        // this.getList()
      },
      changeCountyXZ(e) {
        this.newData.authProvincesCityAreas = e
      },
      cityLs() {
        var _this = this
        selectByPCityAreas(_this.address)
          .then(res => {
            if (res.data.code == 0) {
              console.log(res)
              // res.data.data.forEach(item=>{
              //   Vue.set(item,'checked',false)
              // })
              _this.cityList = res.data.data
              _this.options = res.data.data
            } else {
              _this.$message({
                type: 'info',
                message: res.data.msg
              })
            }
          })
      },
      addFY(item) {
        this.xzItem = item
        this.newFY.deptId = item.deptId
        this.listFY.deptId = item.deptId
        this.listFY.realName = ''
        this.listFY.phone = ''
        this.showEditDialog = true
        this.fileDate.deptId = item.deptId
        this.fileDate.optAuthType = this.info.optAuthType
        this.listFY.pageNo = 1
        this.getListFY()
      },
      getListFY() {
        var _this = this
        getUserListByDeptId(_this.listFY)
          .then(res => {

            if (res.data.code == 0) {
              console.log(res)
              // res.data.data.forEach(item=>{
              //   Vue.set(item,'checked',false)
              // })
              _this.totalFY = res.data.data.total
              _this.fangyiList = res.data.data.records
              console.log(res.data.data.records)
            } else {
              _this.$message({
                type: 'info',
                message: res.data.msg
              })
            }
          })
      },
      edit(item) {
        this.newData.authProvincesCityAreas = []
        this.wListItem = item
        this.showAddDialog = true
        this.newData.provincialAndMunicipalLevel = item.provincialAndMunicipalLevel
        this.newData.adminUserName = item.adminUserName
        this.newData.adminUserPhone = item.adminUserPhone
        this.newData.optUserName = item.optUserName
        this.newData.optUserPhone = item.optUserPhone
        this.newData.name = item.name
        if (this.info.provincialAndMunicipalLevel == '2' && this.handleIndex == 0) {
          this.newData.authProvincesCityAreas = item.authProvincesCityAreas
          this.addTitle = '编辑县区级组织机构'
        } else {
          console.log('111111111')
          console.log(item.authProvincesCityAreas)
          this.addTitle = '编辑乡镇街道级组织机构'
          if (item.authProvincesCityAreas.indexOf(',') == -1) {
            // if()
            this.newData.authProvincesCityAreas.push(item.authProvincesCityAreas)
            console.log(this.newData.authProvincesCityAreas)
          } else {
            let array = []
            array = item.authProvincesCityAreas.split(',')
            console.log(array)

            this.newData.authProvincesCityAreas = this.newData.authProvincesCityAreas.concat(array)


          }
        }

      },
      editFangYi(item) {
        console.log(item)
        this.itemFYSta = item
        this.newFY.id = item.id
        this.newFY.realName = item.realName
        this.newFY.phone = item.userAccount
        console.log(this.newFY)
        this.editName = false
        this.editPhone = false
        this.editBtn = false
      },
      editCancelFangYi(item) {
        this.editName = true
        this.editPhone = true
        this.editBtn = true
      },
      editSaveFangYi(item) {

        this.editName = true
        this.editPhone = true
        this.editBtn = true

        updateAuthUserFY(this.newFY)
          .then(res => {
            if (res.data.code == 0) {
              console.log(res)
              this.showAddDialog = false
              this.$message({
                type: 'success',
                message: '修改成功'
              })
              this.getListFY()
            } else {
              this.$message({
                type: 'info',
                message: res.data.msg
              })
            }
          })
      },

      fangyiyuan(item) {
        console.log(item)
        this.showFangYiListDialog = true
        this.xzItem = item
        this.listFY.deptId = item.deptId
        this.getListFY()
      },

      // edit(item){
      //   console.log(item)
      //   this.newData.phone = item.userAccount
      //   this.newData.realName = item.realName
      //   this.active = item.optAuthType
      //   this.newData.id = item.id
      //   this.newData.authProvincesCityAreas = []
      //     this.newData.optAuthType = item.optAuthType.toString()
      //   if(item.authProvincesCityAreas.indexOf(',')==-1){
      //     // if()
      //      this.newData.authProvincesCityAreas.push(item.authProvincesCityAreas)
      //      console.log(this.newData.authProvincesCityAreas)
      //   }else{
      //     let array = []
      //    array =  item.authProvincesCityAreas.split(',')
      //     console.log(array)

      //    this.newData.authProvincesCityAreas =  this.newData.authProvincesCityAreas.concat(array)
      //     console.log(this.newData.authProvincesCityAreas)
      //    console.log(array)

      //   }
      //   //this.addTitle = '编辑县区级组织机构'
      //   if(this.handleIndex==0){
      //     this.addTitle  = '编辑县区级组织机构'
      //   }else{
      //     this.addTitle  = '编辑乡镇街道级组织机构'
      //   }

      //   this.showAddDialog = true
      // },
      confirmsBtn() {
        addOrUpdateAuthUser(this.newFY)
          .then(res => {

            console.log(res)
            if (res.data.code == 0) {
              this.showAddsDialog = false
              this.getListFY()
            } else {
              this.$message({
                type: 'info',
                message: res.data.msg
              })
            }
          })
      },
      addDeptS() {
        addDept(this.newData)
          .then(res => {
            if (res.data.code == 0) {
              console.log(res)
              this.showAddDialog = false
              this.loading = true
              this.$message({
                type: 'success',
                message: '新增成功'
              })
              this.getList()
            }
          }).catch(res=>{
            console.log('catchcatch')
            if (this.newData.authProvincesCityAreas.indexOf(',') == -1) {
              // if()
              let array = []
              array.push( this.newData.authProvincesCityAreas)
              this.newData.authProvincesCityAreas = array
              console.log(this.newData.authProvincesCityAreas)
            } else {
              let array = []
              array =  this.newData.authProvincesCityAreas.split(',')
              console.log(array)
              this.newData.authProvincesCityAreas = this.newData.authProvincesCityAreas.concat(array)


            }
          })
      },
      uptDeptS() {
        updateDept(this.newData)
          .then(res => {
            if (res.data.code == 0) {
              console.log(res)
              this.showAddDialog = false
              this.loading = true
              this.$message({
                type: 'success',
                message: '修改成功'
              })
              this.getList()
            } else {
              this.$message({
                type: 'info',
                message: res.data.msg
              })
            }
          }).catch(res=>{
            console.log('catchcatch')
            if (this.newData.authProvincesCityAreas.indexOf(',') == -1) {
              // if()
              let array = []
              array.push( this.newData.authProvincesCityAreas)
              this.newData.authProvincesCityAreas = array
              console.log(this.newData.authProvincesCityAreas)
            } else {
              let array = []
              array =  this.newData.authProvincesCityAreas.split(',')
              console.log(array)
              this.newData.authProvincesCityAreas = this.newData.authProvincesCityAreas.concat(array)


            }
          })
      },
      confirmBtn() {
        if (this.newData.name == '') {
          this.$message({
            type: 'info',
            message: '请输入组织机构名称'
          })
        } else if (this.newData.adminUserName == '') {
          this.$message({
            type: 'info',
            message: '请输入管理员姓名'
          })
        } else if (this.newData.authProvincesCityAreas.length < 1) {
          this.$message({
            type: 'info',
            message: '请选择辖区'
          })
        } else if (this.newData.adminUserPhone == '') {
          this.$message({
            type: 'info',
            message: '请输入管理员手机号'
          })
        } else if (this.newData.optUserName == '') {
          this.$message({
            type: 'info',
            message: '请输入操作员姓名'
          })
        } else if (this.newData.optUserPhone == '') {
          this.$message({
            type: 'info',
            message: '请输入操作员手机号'
          })
        } else {
          if (this.info.provincialAndMunicipalLevel == '2') {
            if (this.addTitle == '编辑县区级组织机构') {
              this.newData.deptId = this.wListItem.deptId
              this.uptDeptS()
            } else {
              this.addDeptS()
            }

          } else {
            if(this.newData.authProvincesCityAreas.length>1){
               this.newData.authProvincesCityAreas = this.newData.authProvincesCityAreas.join(',')
            }else{
              this.newData.authProvincesCityAreas  = this.newData.authProvincesCityAreas[0]
            }

            if (this.addTitle == '编辑乡镇街道级组织机构') {
              this.newData.deptId = this.wListItem.deptId
              this.uptDeptS()
            } else {
              this.addDeptS()
            }

            // this.addDeptS()
          }




        }
        // if(this.addTitle=='新增县区级组织机构'||this.addTitle=="新增乡镇级街道组织机构"){
        //   this.newData.id = null
        //   addDept(this.newData)
        //   .then( res => {
        //     if (res.data.code==0) {
        //       console.log(res)
        //       this.showAddDialog = false
        //        this.loading = true
        //        this.$message({
        //            type: 'success',
        //            message: '人员操作成功'
        //          })
        //       this.getList()
        //     } else {
        //       this.$message({
        //         type: 'info',
        //         message: res.data.msg
        //       })
        //     }
        //   })
        // }else{
        //   editOrUpdate(this.newData)
        //   .then( res => {
        //     if(res.data.code==0){
        //       this.showAddDialog = false
        //        this.loading = true
        //        this.$message({
        //            type: 'success',
        //            message: '人员操作成功'
        //          })
        //       this.getList()
        //     }else{
        //        this.showAddDialog = false
        //       this.$message({
        //         type: 'info',
        //         message: res.data.msg
        //       })

        //     }
        //   })
        // }

        // }

      },
      closeDialog() {
        this.showAddDialog = false
        this.showAddsDialog = false
      },
      // types(item,index){
      //   this.active = index
      //   this.newData.optAuthType = item.value
      // },
      changeName(e) {
         this.form.pageNo = 1
        this.form.realName = e
        this.loading = true
        this.getList()
      },
      changeNames(e) {
        this.form.pageNo = 1
        this.form.name = e
        this.loading = true
        this.getList()
      },
      changePhone(e) {
        this.form.pageNo = 1
        // console.log(e)
        this.form.phone = e
        // this.loading = true
        // this.getList()
      },
      // 页码
      currentPage(e) {
        this.loading = true
       this.form.pageNo = e
        this.getList()
      },
      prev(e) {
        this.loading = true
        this.form.pageNo = e
        this.getList()
      },
      next(e) {
        this.loading = true
        this.form.pageNo = e
        this.getList()
      },
      // 防疫分页
      currentPageFY(e) {
        this.loading = true
       this.listFY.pageNo = e
        this.getListFY()
      },
      prevFY(e) {
        this.loading = true
        this.listFY.pageNo = e
       this.getListFY()
      },
      nextFY(e) {
        this.loading = true
        this.form.pageNo = e
       this.getListFY()
      },



      handleChange(item) {
        let cityList = this.$refs['city'].getCheckedNodes()[0].pathLabels
        this.form.cityName = cityList[1]

        this.form.provinceName = cityList[0]
        if (cityList[2] == '全部地区') {
          this.form.countyName = ''
        } else {
          this.form.countyName = cityList[2]
        }
        if (cityList[1] == '全部市区') {
          this.form.cityName = ''
        } else {
          this.form.cityName = cityList[2]
        }

      },
      onSubmit() {
        this.form.pageNo = 1
        this.getList()
      },
      onSubmitFY() {
        this.form.pageNo = 1
        this.getListFY()
      },
      reset() {
        this.form.name = ''
        this.form.realName = ''
        this.form.phone = ''
        this.form.queryCityAreas = ''

        this.form.authProvincesCityAreas = this.info.authProvincesCityAreas
        this.getList()
      },
      deletes(item) {
        this.$confirm('是否删除本条数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var _this = this
          delDept({
              id: item.deptId,

            })
            .then(res => {
              if (res.data.code == 0) {
                _this.$message({
                  type: 'success',
                  message: '删除成功'
                })
                this.getList()
              } else {
                _this.$message({
                  type: 'info',
                  message: res.data.msg
                })

              }

            })

        }).catch(() => {});

      },
      // 删除防疫员
      deleteFY(item) {
        this.$confirm('是否删除本条数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var _this = this
          delAuthUserFY({
              id: item.id,

            })
            .then(res => {
              if (res.data.code == 0) {
                _this.$message({
                  type: 'success',
                  message: '删除成功'
                })
                this.getListFY()
              } else {
                _this.$message({
                  type: 'info',
                  message: res.data.msg
                })

              }

            })

        }).catch(() => {});

      },
      addprevention() {
        this.showAddsDialog = true
      },
      addPerson() {
        this.newData.deptId = ''
        this.newData.adminUserName= ''
        this.newData.adminUserPhone= ''
        this.newData.name= ''
        this.newData.optUserName= ''
        this.newData.authProvincesCityAreas = []
        this.newData.optUserPhone= ''
        /* this.newData.provincialAndMunicipalLevel= '' */
        this.showAddDialog = true
        if (this.info.provincialAndMunicipalLevel == '2') {
          this.addTitle = '新增县区级组织机构'
        } else {
          this.addTitle = '新增乡镇街道级组织机构'
        }

        // this.newS = 0
      },
      getList() {

        var _this = this

        selectAllDept(this.form)
          .then(res => {
            _this.loading = false
            if (res.data.code == 0) {
              _this.total = res.data.data.total
              _this.userList = res.data.data.records
            } else {
              _this.$message({
                type: 'info',
                message: res.data.msg
              })
            }
          }).catch(res => {
            _this.loading = false
          })
      },
    },
    // 注册组件
    components: {

    },
    created() {

    },
  }
</script>

<style scoped>
  /deep/ .el-tabs__item {
    width: 110px;
    height: 60px;
    text-align: center;
    font-size: 17px;
    padding: 5px 0;
    cursor: pointer;
  }

  /deep/ .el-tabs__item.is-active {
    color: #30BF30;
    font-weight: bold;
  }

  /deep/ .el-tabs__active-bar {
    width: 110px;
  }

  /deep/ .el-tabs__nav-wrap::after {
    height: 1px
  }

  .el-button--primary {
    float: right;
  }

  .el-button--primary:focus,
  .el-button--primary:hover {
    background-color: #30BF30;
    border-color: #30BF30;
  }

  /deep/ .el-button--success.is-plain {
    border-color: rgba(48, 191, 48, 1);
    color: #30BF30 !important;
    background: #fff;
  }

  /deep/ .el-button--info.is-plain {
    background: rgba(245, 245, 245, 1);
    color: #333;
    border-color: rgba(245, 245, 245, 1)
  }

  .layuiPdaList {
    height: calc(100vh - 384px);
    overflow-y: auto;
  }

  @media (max-width: 1500px) {
    .layuiPdaList {
      height: calc(100vh - 445px);
    }
  }

  .title {
    height: 60px;
    line-height: 60px;
    margin: 0;
  }

  .title h3 {
    margin: 0 !important;
  }

  .title h3 span {
    font-weight: normal;
    font-size: 16px;
    margin-left: 10px;
  }

  /deep/.el-main {
    background: #f7f7f7 !important;
  }

  /deep/ .el-table th.el-table__cell.is-leaf:nth-child(5) div,
  /deep/ .el-table--enable-row-transition .el-table__body td.el-table__cell:nth-child(5) div {
    text-align: left !important;
  }

  /deep/ .el-button {
    padding: 11px 10px;
    font-size: 15px
  }

  /deep/ .editTable.el-table th.el-table__cell.is-leaf:nth-child(5) div,
  /deep/ .editTable.el-table--enable-row-transition .el-table__body td.el-table__cell:nth-child(5) div {
    text-align: center !important;
  }

  .pdaBoxs {
    background: #fff;
    padding: 20px 0px 10px 0px;
  }


  .btnBox {
    float: right;
    font-size: 16px
  }

  .btnBox button {
    font-size: 16px;
    height: 40px;
    padding: 0 20px;
    line-height: 40px;
  }

  .actionBox div {
    display: inline-block;
    margin: 0 5px;
    color: #4C7399;
  }

  .maskBox {
    width: 100% !important;
    /* height: 600px!important; */
  }

  .absolutes {
    height: 420px;
    overflow-y: auto;
  }

  .absolutes::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: #F5F5F5;
  }

  .absolutes::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    background-color: #F5F5F5;
  }

  .maskBox::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
    background-color: #dfdfdf;
  }

  .leftBlock {
    float: left;
    width: 45%;
    font-size: 16px;
    color: #333;
    margin-top: 10px;
    margin-bottom: 0 !important;
    padding-bottom: 10px;
    margin-right: 4%;
    position: relative;
    clear: none !important;
  }

  .leftBlock:nth-child(2n-1) {
    margin-right: 4% !important;
  }

  .leftBlock .red {
    color: red;
  }

  .color99 {
    color: #999;
  }

  .mar_t15 {
    margin-top: 10px;
  }

  .layui-input-block {
    position: relative;
    margin-left: 0 !important;
    min-height: 36px;
  }

  .layui-input-block.inputRadio>div {
    cursor: pointer;
    position: relative;
    display: inline-block;
  }

  .layui-input-block.inputRadio>div>input {
    width: 50px;
    position: relative;
    z-index: 99999;
    cursor: pointer;
  }

  .layui-input-block.inputRadio>div>input::after {
    content: '';
    position: absolute;
    left: 13px;
    top: -3px;
    width: 20px;
    height: 20px;
    background: url(/static/images/radius.svg) no-repeat center;
    background-size: 20px auto;
  }

  .layui-input-block.inputRadio>div>input[type="radio"]:checked::after {
    background: url(/static/images/radius_checked.png) no-repeat center;
    background-size: 20px auto
  }

  .layui-input-block.inputRadio>div>span {
    position: absolute;
    right: 0px;
  }

  .layui-input,
  .layui-textarea,
  select {
    height: 40px;
    border-radius: 5px;
  }

  .layui-input,
  .layui-textarea,
  select {
    display: block;
    width: 100%;
    text-indent: 10px;
  }

  .layui-input,
  .layui-textarea,
  select {
    border: solid 1px #e6e6e6;
    outline: none;
    background: transparent !important;
  }

  .descriptB {
    position: absolute;
    bottom: -20px;
    left: 0;
    color: #999999;
    font-size: 16px;
  }

  .ds_I {
    display: inline-block;
  }

  .baozhuang>input {
    height: 36px;
    width: 100px !important;
    float: left;
    text-indent: 10px;
    margin-right: 15px;
    border: solid 1px #e6e6e6
  }

  .baozhuang>select {
    height: 40px;
    width: 100px !important;
    float: left;
    margin-right: 15px;
  }

  .baozhuang>select:last-child {
    margin-right: 0;
  }

  .baozhuang span {
    float: left;
    margin-right: 15px;
    margin-top: 10px;
  }

  .rkConfrim.cur {
    cursor: pointer;
    background: #30BF30;
    color: #fff;
  }

  .addConfrim {
    margin-top: 70px !important;
  }

  .rkConfrim {
    color: #999999;
    background: #F5F7FA;
    border-radius: 5px;
    width: 100px;
    height: 40px;
    line-height: 40px;
    margin: 0px auto 0;
    text-align: center;
    position: relative;
  }

  .rkInputBlock {
    overflow: hidden;
    margin: 60px 60px;
  }

  .rkInputBlock>div {
    float: left;
    position: relative;
    line-height: 40px;
  }

  .rkInputBlock2 img {
    width: 80px;
    display: block;
    margin: 0 auto 20px;
  }

  .rkInputBlock.rkInputBlock2>div {
    font-size: 16px;
    color: #333;
    text-align: center;
  }

  .rkInputBlock.rkInputBlock2>div {
    float: none;
  }

  .mar_r20 {
    margin-right: 20px;
  }

  .rkInput {
    width: 100%;
    border: 1px solid #D9D9D9;
    border-radius: 5px;
    margin-bottom: 15px;
    position: relative;
  }

  .rkInput input {
    border: none !important;
    text-indent: 20px;
    width: 80%;
    height: 35px;
    outline: none;
  }

  .danWei {
    position: absolute;
    top: 0;
    right: 15px;
    color: #999999;
  }

  .bgF5 {
    background: #F5F7FA !important;
  }

  .rknumss div {
    height: 40px;
    line-height: 40px;
    margin-bottom: 20px;
    cursor: pointer;
  }

  .rknumss label {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: url(/static/images/radius.svg) no-repeat center;
    background-size: 20px 20px;
    float: left;
    cursor: pointer;
    margin-right: 10px;
    margin-top: 10px;
  }

  .rknumss div.checked label {
    background: url(/static/images/radius_checked.png) no-repeat center;
    background-size: 20px 20px;
  }

  .rknumss span {
    font-size: 15px;
    color: #333;
    float: left;
  }

  .rknumss input {
    width: 60%;
    height: 40px;
    line-height: 40px;
    background-color: rgba(255, 255, 255, 0);
    border: solid 1px rgba(217, 217, 217, 1);
    border-radius: 5px;
    text-align: center;
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
    font-size: 18px;
    float: right;
    outline: none;
    padding: 0;
  }

  .rknumss input:disabled {
    background-color: rgba(245, 247, 250, 1);
  }

  .hide {
    display: none;
  }

  .delBtnBox {
    text-align: center;
  }

  .delBtnBox div {
    display: inline-block;
    margin: 0 10px;
    cursor: pointer;
  }

  .tit {
    font-size: 16px;
    color: #999;
  }

  .tit a {
    color: #30BF30
  }

  .red {
    color: red;
  }

  .typess div {
    cursor: pointer;
    display: inline-block;
    padding: 0px 15px;
    border: 1px solid #F5F7FA;
    background: #F5F7FA;
    color: #333;
    border-radius: 5px;
    margin-right: 20px;
    height: 40px;
    line-height: 40px;
    margin-bottom: 10px;
    font-size: 14px;
  }

  .typess div.cur {
    background-color: #fff;
    border: 1px solid #30bf30;
    color: #30bf30;
  }

  /deep/ .el-checkbox {
    width: 100px !important;
    margin: 5px 0;
  }

  /deep/ .el-message-box {
    width: 300px !important;
  }

  /deep/ .cityLists.leftBlock .el-select {
    width: 100%;
  }

  /deep/ .cityLists.leftBlock .el-select .el-tag.el-tag--info {
    font-size: 15px;
  }

  .fixedTop {
    font-family: MyFontName;
  }

  .maskBox h1,
  .maskBoxs h1 {
    font-size: 16px;
    color: #333;
    text-align: center;
    font-weight: 700;
    margin: 0 0 15px 0;
  }

  .maskBox h1 span {
    text-align: center;
    margin-left: 10px;
    background-color: rgba(229, 229, 229, 1);
    border: none;
    border-radius: 4px;
    font-size: 12px;
    color: #666666;
    display: inline-block;
    padding: 2px 8px;
    font-weight: normal;
  }

  .btnBox button b,
  .maskBoxs h1 b {
    height: 20px;
    line-height: 21px;
    padding: 0 10px;
    background: linear-gradient(270deg, rgba(217, 33, 33, 1) 0%, rgba(255, 74, 38, 1) 100%);
    color: #fff;
    border-radius: 10px;
    margin-left: 10px;
    display: inline-block;
  }

  .pages {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .actionBox div.cancel {
    color: #666;
  }

  .actionBox div.save {
    font-size: 16px;
    height: 30px;
    width: 60px;
    text-align: center;
    line-height: 30px;
    color: #FFF;
    border-radius: 4px;
    background-color: #30BF30;
    border-color: #30BF30;
    margin-left: 10px;
  }

  /deep/ .elTable.el-table .cell {
    text-align: left;
  }

  /deep/ .elTable.el-table .has-gutter tr th:nth-child(7) div {
    text-align: center;
  }

  @font-face {
    font-family: MyFontName;
    src: url('https://image1.besushuo.com/common/ziti/%E8%8B%B9%E6%96%B9%E9%BB%91%E4%BD%93-%E4%B8%AD%E7%B2%97-%E7%AE%80.ttf')
  }

  .tc {
    text-align: center !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/system/organizational.vue